import { Base64ToBlob } from "@/helper/shareHelper";
import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";
import { PeakSource } from "./../../enums/enums";

class MerchantService {
  GetMerchantDetail() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI.post("/api/Merchant/GetMerchantDetail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  GetMerchantRevenueDepartmentContact() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakTaxAPI
      .post("/api/Merchant/GetMerchantRevenueDepartmentContact", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  UpdateMerchantRevenueDepartmentContact(id: number) {
    const data = {
      contactId: id,
    };
    const _input = {
      merchantId: MerchantId(),
      data: data,
    };
    return service.peakTaxAPI
      .post("/api/Merchant/UpdateMerchantRevenueDepartmentContact", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoInsertMerchant(input: any) {
    const _input = {
      merchantId: 0,
      source: PeakSource.PeakTax,
      userName: input.userEmail,
      createMerchantModel: input.createMerchantModel,
      language: i18n.locale,
    };
    return service.peakRealTimeAPI.post("/api/Merchant/InsertMerchant", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetMerchantAddressList() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI
      .post("/api/Merchant/GetMerchantAddressList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateMerchantDetail(merchant: any) {
    const _input = {
      merchantId: MerchantId(),
      merchant: merchant.data,
    };
    const headers = SetHeaderService();

    if (merchant.pinToken) {
      (headers.headers as any)["X-PIN-Token"] = merchant.pinToken;
    }

    return service.peakRealTimeAPI.post("/api/Merchant/UpdateMerchant", _input, headers).then((res) => {
      return res;
    });
  }
  DoVerificationMerchant(verificationMerchantModel: any) {
    const _input = {
      merchantId: MerchantId(),
      verificationMerchantModel: verificationMerchantModel,
    };
    return service.peakRealTimeAPI
      .post("/api/Merchant/VerificationOrganizationMerchant", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoVerificationMerchantByMatchLink(verificationMerchantModel: any) {
    const _input = {
      merchantId: MerchantId(),
      data: verificationMerchantModel,
    };
    return service.peakAppConnect
      .post("/api/MatchLink/VerificationMerchant", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateMerchantLogoAndStamp(updateMerchantLogoAndStamp: any) {
    const formData = new FormData();
    const updateMerchantLogoAndStampData = {
      ...updateMerchantLogoAndStamp,
    };
    delete updateMerchantLogoAndStampData.logo;
    delete updateMerchantLogoAndStampData.Stamp;
    formData.append("merchantId", MerchantId());
    if (updateMerchantLogoAndStamp.logo.rawString.startsWith("data:")) {
      const blobLogo = Base64ToBlob(
        updateMerchantLogoAndStamp.logo.rawString,
        updateMerchantLogoAndStamp.logo.fileType
      );
      formData.append(`logo`, blobLogo, updateMerchantLogoAndStamp.logo.fileName);
    }
    if (updateMerchantLogoAndStamp.Stamp.rawString.startsWith("data:")) {
      const blobStamp = Base64ToBlob(
        updateMerchantLogoAndStamp.Stamp.rawString,
        updateMerchantLogoAndStamp.Stamp.fileType
      );
      formData.append(`stamp`, blobStamp, updateMerchantLogoAndStamp.Stamp.fileName);
    }
    formData.append("updateMerchantLogoAndStamp", JSON.stringify(updateMerchantLogoAndStampData));
    return service.peakRealTimeAPI
      .post("/api/Merchant/UpdateMerchantLogoAndStamp", formData, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoRefreshVerifiedStatus() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI
      .post("/api/Merchant/RefreshVerifiedStatus", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoActionSettingAutoInsertPeakTaxData(settingData: any) {
    const _input = {
      merchantId: MerchantId(),
      data: settingData,
    };
    return service.peakTaxAPI
      .post("/api/Merchant/ActionSettingAutoInsertPeakTaxData", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetSettingAutoInsertPeakTaxData() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakTaxAPI
      .post("/api/Merchant/GetSettingAutoInsertPeakTaxData", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetConnectPeakWithMerchantId() {
    const _input = {
      merchantId: MerchantId(),
      source: PeakSource.PeakTax,
    };
    return service.peakTaxAPI
      .post("/api/Merchant/GetConnectPeakWithMerchantId", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateConnectPeakWithMerchantId(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        isPeakPayrollConnected: input.isPeakPayrollConnected,
        isPeakTaxConnected: input.isPeakTaxConnected,
      },
    };
    return service.peakTaxAPI
      .post("/api/Merchant/UpdateConnectPeakWithMerchantId", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetMerchantListByUserId(isUseMainDatabase = false) {
    const headers = SetHeaderService().headers;
    const params = { isUseMainDatabase: isUseMainDatabase };
    return service.peakRealTimeAPIForUser
      .get("/api/Merchant/GetMerchantListByUserId", { params, headers })
      .then((res) => {
        return res;
      });
  }
  DoGetSelectedMerchant(merchantId: number) {
    const headers = SetHeaderService().headers;
    const params = { merchantId: merchantId };
    return service.peakRealTimeAPIForUser
      .get(`/api/v2/Merchant/GetSelectedMerchant`, { params, headers })
      .then((res) => {
        return res;
      });
  }
  DoGetFavoriteMerchant() {
    const _input = {};
    return service.peakExportAPI.post("/api/Merchant/GetFavoriteMerchant", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateFavoriteMerchant(merchantId: number) {
    const _input = {
      merchantId: merchantId,
    };
    return service.peakExportAPI
      .post("/api/Merchant/UpdateFavoriteMerchant", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoDeleteFavoriteMerchant(merchantId: number) {
    const _input = {
      merchantId: merchantId,
    };
    return service.peakExportAPI
      .post("/api/Merchant/DeleteFavoriteMerchant", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new MerchantService();
